import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import "./AddEstablishedPers.css";

function getSteps() {
  return [
    "Lender Details",
    "HOA Questionnaire (1076)",
    "Application for Approval (1091)",
    "Appraisal (1073)",
    "Additional Documents",
    "Review PERS input",
    "Confirm PERS creation​",
    // "Issue PERS Decision",
    "Attachments",
    "Confirm Attachment Upload​"
  ];
}

export default function FormStepper(props) {
  const { step } = props;
  const steps = getSteps();
  return (
    <div className="step-container">
      <Stepper className="step" activeStep={step} orientation="vertical">
        {steps.map((label, index) => {
          const stepProps = {};
          const labelProps = {};
          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
}
